import { render } from "./TransferOwnershipModal.vue?vue&type=template&id=75f11d3f&scoped=true&ts=true&lang=pug"
import script from "./TransferOwnershipModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransferOwnershipModal.vue?vue&type=script&setup=true&lang=ts"

import "./TransferOwnershipModal.vue?vue&type=style&index=0&id=75f11d3f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f11d3f"]])

export default __exports__